/**
 * Generated by orval v7.8.0 🍺
 * Do not edit manually.
 * TopTopTime API
 * <:3 )~~~~    =^.^=
 * OpenAPI spec version: 0.0.1
 */

export enum GetOtpSendStatus200Status {
  pending = 'pending',
  accepted = 'accepted',
  delivered = 'delivered',
  failed = 'failed',
  unknown = 'unknown'
}
